export default function round(number, precision = 2) {

    if (typeof precision !== "number") precision = 2;

    const shift = function (number, precision) {
        const numArray = ("" + number).split("e");
        return +(numArray[0] + "e" + (numArray[1] ? (+numArray[1] + precision) : precision));
    };
    return shift(Math.round(shift(number, +precision)), -precision);
}